import GrowthMap from './GrowthMap';

export default GrowthMap;
